import { render, staticRenderFns } from "./FrameSelectionBooking.vue?vue&type=template&id=b3ca6fa0&scoped=true&"
import script from "./FrameSelectionBooking.vue?vue&type=script&lang=js&"
export * from "./FrameSelectionBooking.vue?vue&type=script&lang=js&"
import style0 from "./FrameSelectionBooking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FrameSelectionBooking.vue?vue&type=style&index=1&id=b3ca6fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ca6fa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDatePicker,VDialog,VIcon,VMenu,VSelect})
